export const errorCodes = {
  EXTERNAL_USER_NOT_FOUND: 40028,
  EMAIL_ALREADY_TAKEN: 40030,
  EXTERNAL_USER_PASSWORD_CODE_NOT_MATCH: 40045,
  EXTERNAL_USER_PASSWORD_CODE_EXPIRED: 40046,
  WAIT_MINUTE_BEFORE_NEXT_LOGIN: 40193,
  EMAIL_OR_PASSWORD_NOT_CORRECT: 40029,
  REFERRAL_NOT_FOUND: 40164,
};
